type SectionContentType = {
    children?: any
}
export default function SectionContent({children}: SectionContentType) {
    return (
        <div className="section-content">
            {children}
        </div>
    )
}